import { ServerBaseEntity } from '@iris/common/models/ServerBaseEntity';
import { IrisTagType } from '@iris/common/models/IrisTag';

export enum IrisDMSTagType {
  Project = 'Project',
  Public = 'Public',
}

export const dmsTagTypes = [
  { name: IrisDMSTagType.Project, label: 'label.Project' },
  { name: IrisDMSTagType.Public, label: 'label.Public' },
];

export interface IrisDMSTagI extends ServerBaseEntityI {
  name: string;
  type: IrisTagType | IrisDMSTagType;
  value: string;
  owner: number;
  color: string;
  projectId: number;
  isActive: boolean;
  used?: number;
  selected?: boolean;
  totalFileCount?: number;
  isPublicTag(): boolean;
}

export class IrisDMSTag extends ServerBaseEntity<IrisDMSTag> implements IrisDMSTagI {
  name: string = undefined;
  type: IrisTagType | IrisDMSTagType = IrisTagType.DMS;
  value: string = undefined;
  owner: number = undefined;
  color: string = undefined;
  projectId: number = undefined;
  isActive = true;
  used?: number = undefined;
  selected?: boolean = undefined;
  totalFileCount?: number = undefined;

  constructor(params?: Partial<IrisDMSTagI>) {
    super(params);
    if (params) {
      Object.assign(this, params);
    }
  }

  isPublicTag(): boolean {
    return !this.projectId;
  }
}
